import { ReactNode, useContext } from "react";

import { ApiResolverContext } from "../ApiResolverProvider/ApiResolverContext";
import { AuthenticationContext } from "./AuthenticationContext";
import { useAuthentication } from "./useAuthentication";

export const AuthenticationProvider = ({
  children,
  userType,
}: {
  children: ReactNode;
  userType: "staff" | "member";
}) => {
  const apiMeta = useContext(ApiResolverContext);
  const authentication = useAuthentication({
    serverDetails: apiMeta,
    userType,
  });

  return (
    <AuthenticationContext.Provider value={authentication}>
      {children}
    </AuthenticationContext.Provider>
  );
};
